import SuccessIcon from '@/assets/img/icons/success-v2.svg';
import DeniedIcon from '@/assets/img/icons/denied.svg';
import PendingIcon from '@/assets/img/icons/pending.svg';
import ErrorIcon from '@/assets/img/icons/error.svg';
import ConfirmationIcon from '@/assets/img/id-pay-confirmation.svg';

export default {
    paid: {
        icon: SuccessIcon,
        biggerIcon: false,
        showShippingSummary: true,
        showOrderSummary: true,
        title: 'paymentApproved',
        texts: [
            {
                text: 'paymentApprovedText',
                hasMerchantName: true,
            }
        ],
    },
    denied: {
        icon: DeniedIcon,
        biggerIcon: false,
        showShippingSummary: false,
        showOrderSummary: false,
        title: 'paymentRefused',
        texts: [
            {
                text: 'paymentDeniedText',
                hasMerchantName: false,
            }
        ],
    },
    pending: {
        icon: PendingIcon,
        biggerIcon: false,
        showShippingSummary: true,
        showOrderSummary: true,
        title: 'paymentUnderReview',
        texts: [
            {
                text: 'paymentUnderReviewText1',
                hasMerchantName: true,
            },
            {
                text: 'paymentUnderReviewText2',
                hasMerchantName: false,
            },
        ],
    },
    idpay_pending: {
        showShippingSummary: true,
        showOrderSummary: true,
    },
    openfinancepending: {
        icon: PendingIcon,
        biggerIcon: false,
        showShippingSummary: true,
        showOrderSummary: false,
        title: 'paymentUnderReview',
        texts: [
            {
                text: 'openFinanceWaitingConfirm',
                hasMerchantName: false,
            }
        ],
    },
    canceled: {
        icon: ConfirmationIcon,
        biggerIcon: true,
        showShippingSummary: false,
        showOrderSummary: false,
        title: 'paymentCanceled',
        texts: [
            {
                text: 'paymentCanceledText',
                hasMerchantName: false,
            }
        ],
    }
};